import {useIsResponsiveFoldable} from '../../../../common/useIsResponsiveFoldable.hook';
import useTypedSelector from '../../../../common/useTypedSelector';
import {SectionType} from '../../../../graphql/generated/types';
import {CommonGroupProps} from '../../type';
import {Banner} from './Banner';
import EventBannerGrid from './EventBannerGrid';

export function ResponsiveBanner({children, group}: CommonGroupProps) {
  const parentSection = useTypedSelector(state => {
    const sectionId = state.pagewebLayout.relations.groups[group.id].parentId;
    return state.pagewebLayout.entities.sections[sectionId];
  });

  const isFoldable = useIsResponsiveFoldable();

  // TOP 섹션은 responsive 상관 없이 무조건 슬라이딩 배너입니다
  const BannerComponent =
    parentSection.type === SectionType.Top
      ? Banner
      : isFoldable
        ? EventBannerGrid
        : Banner;

  return <BannerComponent group={group}>{children}</BannerComponent>;
}
